import { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Shield, Eye, EyeOff, CheckCircle } from 'lucide-react';

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [form, setForm] = useState({ new_password: '', confirm: '' });
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm) { toast.error('Passwörter stimmen nicht überein'); return; }
    if (form.new_password.length < 8) { toast.error('Mindestens 8 Zeichen'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: form.new_password });
      setDone(true);
    } catch (err) { toast.error(err.response?.data?.detail || 'Ungültiger oder abgelaufener Link'); } finally { setLoading(false); }
  };

  if (!token) return <div className="min-h-screen flex items-center justify-center"><p className="text-muted-foreground">Ungültiger Link</p></div>;

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-background">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-8 h-8 bg-primary rounded-sm flex items-center justify-center"><Shield className="w-4 h-4 text-primary-foreground" /></div>
          <span className="font-heading font-black text-xl tracking-tight">Your Hero</span>
        </div>
        {!done ? (
          <>
            <h2 className="font-heading font-bold text-2xl mb-6">Neues Passwort setzen</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1.5">
                <Label>Neues Passwort</Label>
                <div className="relative">
                  <Input type={show ? 'text' : 'password'} value={form.new_password} onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))} placeholder="Mindestens 8 Zeichen" className="rounded-sm pr-10" />
                  <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground" onClick={() => setShow(s => !s)}>{show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}</button>
                </div>
              </div>
              <div className="space-y-1.5">
                <Label>Passwort bestätigen</Label>
                <Input type="password" value={form.confirm} onChange={e => setForm(f => ({ ...f, confirm: e.target.value }))} placeholder="Wiederholen" className="rounded-sm" />
              </div>
              <Button type="submit" className="w-full rounded-sm" disabled={loading}>{loading ? 'Speichern...' : 'Passwort speichern'}</Button>
            </form>
          </>
        ) : (
          <div className="text-center space-y-4">
            <div className="w-16 h-16 bg-emerald-100 rounded-sm flex items-center justify-center mx-auto"><CheckCircle className="w-8 h-8 text-emerald-600" /></div>
            <h2 className="font-heading font-bold text-xl">Passwort geändert</h2>
            <p className="text-sm text-muted-foreground">Ihr Passwort wurde erfolgreich geändert.</p>
            <Button onClick={() => window.location.href = '/login'} className="w-full rounded-sm">Zum Login</Button>
          </div>
        )}
      </div>
    </div>
  );
}
